import { useMemo } from "react";
import { Stack } from "@mui/material";

import WGRShopGroup from "./WGRShopGroup";
import WGRGrandTotal from "./WGRGrandTotal";

export default function WGRViewer({ rows ,grandTotal,summary}) {
  /*
   * Group data by SHOP
   */
  const groupedData = useMemo(() => {
    const map = {};

    rows.forEach((row) => {
      const shop = row.SHOP;

      if (!map[shop]) {
        map[shop] = [];
      }

      map[shop].push(row);
    });

    return Object.keys(map)
      .sort((a, b) => Number(a) - Number(b))
      .map((shop) => ({
        shop,
        rows: map[shop],
      }));
  }, [rows]);

  /*
   * Grand Total
   */
//   const grandTotal = useMemo(() => {
//     return rows.reduce(
//       (total, row) => ({
//         primeLabour:
//           total.primeLabour +
//           Number(row.PRIMECOST_LABOUR || 0),

//         primeStores:
//           total.primeStores +
//           Number(row.PRIMECOST_STORES || 0),

//         onCostLabour:
//           total.onCostLabour +
//           Number(row.ONCOST_LABOUR || 0),

//         onCostStores:
//           total.onCostStores +
//           Number(row.ONCOST_STORES || 0),
//       }),
//       {
//         primeLabour: 0,
//         primeStores: 0,
//         onCostLabour: 0,
//         onCostStores: 0,
//       }
//     );
//   }, [rows]);





// const summary = useMemo(() => {
//   let ds8 = 0;
//   let minDs8 = 0;
//   let mDr = 0;
//   let mfgdRet = 0;
//   let minusMfgdRet = 0;

//   rows.forEach((row) => {
//     const misc = String(row.PRIMECOST_MISC || "").trim().toUpperCase();
//     const amount = Number(row.PRIMECOST_STORES || 0);

//     switch (misc) {
//       case "DS8":
//         ds8 += amount;
//         break;

//       case "MIN DS8":
//         minDs8 += amount;
//         break;

//       case "M-DR":
//         mDr += amount;
//         break;

//       case "MFGD RET.":
//         mfgdRet += amount;
//         break;

//       case "MINUS MFGD RET.":
//         minusMfgdRet += amount;
//         break;

//       default:
//         break;
//     }
//   });

//   return {
//     ds8 : (-1*ds8),
//     minDs8,
//     mDr: (-1*mDr),
//     mfgdRet,
//     minusMfgdRet,
//     directStore:
//       grandTotal.primeStores - ds8 -minDs8 - mDr,
      
//     returnedStore:
//       (-1*(ds8 + minDs8)),
//   };
// }, [rows, grandTotal]);

  
  return (
    <Stack spacing={4}>
      {groupedData.map((group) => (
        <WGRShopGroup
          key={group.shop}
          shop={group.shop}
          rows={group.rows}
        />
      ))}

    
<WGRGrandTotal
  totals={grandTotal}
  summary={summary}
/>




    </Stack>
  );
}